import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ResearchRepository from "./ResearchRepository.jsx"; // adjust path if needed

export default function ResearchRepositoryPage({ categoryKey }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  return (
    <ResearchRepository
      categoryKey={categoryKey}
      navigate={navigate}
      query={query}
      setQuery={setQuery}
    />
  );
}